import React, { Fragment } from 'react'
import { Label } from '../../../components'
import { CHECKBOXES } from '../../../config'
import { getKeyOfOpt, isMatch, lookupOption, renderOptionList } from './optionUtils'

const RadioList = ({
                     id,
                     name,
                     label,
                     helpText,
                     renderStyle,
                     value,
                     context,
                     rtOptions,
                     onChange,
                     optionKeyName,
                     getOptionTextFn,
                   }) => {
  const useCheck = (renderStyle === CHECKBOXES)

  /*
    Translate val (the current value of the selection variable, as far as the UI control/component is concerned)
    into the actual value to be saved in the data context.
  */
  const localChange = (targetValue, isChecked, optKey) => {
    // TODO: see if the useCheck check is really necessary here, or if the two always work the same?
    const val = useCheck
      ? (isChecked ? '' : optKey.toString())
      : targetValue
    return lookupOption(val, rtOptions)
  }

  const localIsMatch = (val, optKey) => {
    // TODO: see if the useCheck check is really necessary here, or if the two always work the same?
    return useCheck
      ? strEqual(val, optKey)
      : isMatch(val, optKey)
  }

  return (
    <Fragment>
      <Label name={name} label={label} helpText={helpText} forId={null}/>
      {renderOptionList(rtOptions, false, context, (opt, scope) => {
        const optKey = getKeyOfOpt(opt, optionKeyName)
        const optId = id + '|' + optKey
        const isChecked = localIsMatch(value, optKey)
        return (
          <div key={optKey} className={useCheck ? 'form-check mt-1' : 'custom-control custom-radio mt-1'}>
            <input type={useCheck ? 'checkbox' : 'radio'}
                   id={optId}
                   name={id}
                   className={useCheck ? 'form-check-input' : 'custom-control-input'}
                   value={optKey}
                   checked={isChecked}
                   onChange={e => onChange(localChange(e.target.value, isChecked, optKey))}
            />
            <Label name={id}
                   label={getOptionTextFn(opt, scope)}
                   forId={optId}
                   className={useCheck ? 'form-check-label' : 'custom-control-label'}
            />
          </div>
        )
      })}
    </Fragment>
  )
}

function strEqual (val1, val2) {
  if (val1 === undefined || val1 === null) return false
  if (val2 === undefined || val2 === null) return false
  return val1.toString() === val2.toString()
}

export default RadioList
